<template>
  <div class="page">
    <initio-panel @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        Driver details
      </template>
      <template v-slot:sidebar>
        <initio-summary class="info-box" />
        <disclosure-block />
      </template>
    </initio-panel>
    
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummary from '@/components/partials/Summary.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import cloneDeep from "lodash.clonedeep";
import { mapGetters } from 'vuex'
import DisclosureBlock from "../../partials/DisclosureBlock";

export default {
  components: {
    DisclosureBlock,
    InitioPanel,
    InitioSummary
  },
  mixins: [
    stepSubmit
  ],
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers'}),
  },
  beforeMount(){
    
    let data_combined = [];

    this.$store.dispatch('getSchema', 'new/driver-details' )
      .then(data => {
        // console.warn('loading schema driver-details.json');

        let driver_dob = this.answers['Vehicle.Confirm'].vehicle_confirm_driver_dob;
  
        function recursiveReplace(element){
          // console.log(element);
          // console.log(index);
          // console.log(array);

          //console.log( element.forEach(recursiveReplace) );
          // element.name = element.name;
          // if (element.label == 'Claim ') {
          //   element.label = element.label;
          // }
          if (element.name == 'driver_details_dob') {
            // console.log(this.$store.state.session_id)
            element.value = driver_dob;
            // console.log(driver_dob)
          }

          for (let [key, value] of Object.entries(element)) {
            if (typeof(value) == 'object') {
              //value.forEach(recursiveReplace);
              for (let [recurse] of Object.entries(value)){
                recursiveReplace(recurse);
              }
            }
            if ( key == 'name' || key == 'id' ){
              // value = value + '_' + j;
            }

            // add loop to conditional keys
            if ( key == 'conditional' ) {
              value.forEach(function(element,index,array){
                // array[index].on = array[index].on + "_" + j;
              })
            }

            if ( key == 'children' || key == 'options' ) {
              // loop through children / options
              if ( Array.isArray(value) ) {
                value.forEach(recursiveReplace);
              } else {
                // element.children = element.children + '' + j;
              }
            }
          }
        }

        // console.error(data);

        // recursively loop through all data
        data.forEach(recursiveReplace);
        // data_combined.push( data[0] );

        this.$store.commit('updateSchema', data);

        // console.log( this.schemaAddDOBInitial(data) );
        // this.$store.commit('updateSchema', this.methods.schemaAddDOBInitial(data))
        
      });

      this.$store.commit('setAnswer',{
        step: 'Vehicle.DriverDetails',
        answer: 'driver_details_main_driver_self',
        value: { 'driver_details_dob': this.answers['Vehicle.Confirm'].vehicle_confirm_driver_dob }
      });

      this.$store.commit('setAnswer',{
        step: 'Vehicle.DriverDetails',
        answer: 'driver_details_main_driver',
        value: { 'driver_details_dob': this.answers['Vehicle.Confirm'].vehicle_confirm_driver_dob }
      });

  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // If step is valid, is new client, hasn't filled in account details
          // and user is driver, attempt to pre-fill the answers

          // console.log(response)
          if ( response.results.new_client_found_by_show_or_hide ) {
            this.$store.commit('updateBackendData', {
                  'Vehicle.CreateAccount': {
                    new_client_found_by_show_or_hide: response.results.new_client_found_by_show_or_hide
                  }
                }
            );
          }
        }, error => {
          console.error("VehicleDriverDetails Error", error);
          context.errors = error;
        });
    }
  },
  data () {
    return {
      errors: [],
      schema: [],
    }
  },
}

</script>

<style scoped lang="scss">
  
</style>